import { useQuery, gql } from "utils/urql";
import { StoryStripQuery } from "types/api";
import SmallPromoItem from "./SmallPromoItem";
import styles from "./StoryStrip.module.scss";
import NativeAd from "../ads/Native";

const query = gql`
  query StoryStrip {
    ${SmallPromoItem.fragment}
    homepageModule(slug: "story-strip", version: "b1") {
      __typename
      ... on HomepagePromoItemList {
        items {
          ...homepageSmallPromoItem
        }
      }
    }
  }
`;

const StoryStrip = () => {
  const [{ data }] = useQuery<StoryStripQuery>({ query });

  if (!data || data.homepageModule?.__typename !== "HomepagePromoItemList") {
    return null;
  }

  const articles = data.homepageModule.items;

  return (
    <ul className={styles.root}>
      {articles.map((article, i) => (
        <li className={styles.li} key={article.id}>
          <SmallPromoItem
            {...article}
            analyticsSection="lower belt"
            lazyImage={true}
            riverIndex={i + 1}
          />
        </li>
      ))}
      <li>
        <NativeAd
          targetingPos="native-belt-hp"
          targetingNative="standard,gift"
          className="s-native s-native--standard s-native--small s-native--short-title s-native--disable-border"
        />
      </li>
    </ul>
  );
};

export default StoryStrip;
